Marionette.Behaviors.behaviorsLookup = function() {
	return window.Behaviors;
};

window.Behaviors = {};